import schema from 'schm';
import { payer as payerSchema } from './infobox.schema';

const coverageStateSchema = schema({
  activeAt: Date,
  activatorId: Number,
  activatorName: String,
  authorizationNumber: '',
  coordinationTypeId: Number,
  isActive: false,
  isBedBound: false,
  medicarePartB: false,
  payer: {},
  payerInput: '',
  payerName: '',
  payers: [],
  payerQuery: '',
  policyNumber: '',
  requiresOxygen: false,
  isRequired: false,
  warnings: [],
});

/**
  * @param {Object} attributes Coverage State
  * @param {Date} [attributes.activeAt]
  * @param {Number} [attributes.activatorId]
  * @param {String} [attributes.activatorName]
  * @param {String} [attributes.authorizationNumber='']
  * @param {Number} [attributes.coordinationTypeId]
  * @param {Boolean} [attributes.isActive=false]
  * @param {Boolean} [attributes.isBedBound=false]
  * @param {Boolean} [attributes.medicarePartB=false]
  * @param {Object} [attributes.payer={}]
  * @param {String} [attributes.payerInput='']
  * @param {String} [attributes.payerName='']
  * @param {Array} [attributes.payers=[]]
  * @param {String} [attributes.payerQuery='']
  * @param {String} [attributes.policyNumber='']
  * @param {Boolean} [attributes.requiresOxygen=false]
  * @param {Boolean} [attributes.isRequired=false]
  * @param {Array} [attributes.warnings=[]]
  * @returns {Promise<*>}
  */
export function createCoverage(attributes) {
  try {
    const coverage = coverageStateSchema.parse(attributes);
    coverage.payer = payerSchema.parse(attributes.payer || {});

    return coverage;
  } catch (errors) {
    throw new Error(`Invalid coverage: ${JSON.stringify(errors)}`);
  }
}

export default coverageStateSchema;
